"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const AuthenticationBodyNotValidError_1 = __importDefault(require("../errors/AuthenticationBodyNotValidError"));
const EmailAlreadyExistsError_1 = __importDefault(require("../errors/EmailAlreadyExistsError"));
const FirebaseUserNotFoundError_1 = __importDefault(require("../errors/FirebaseUserNotFoundError"));
const ForbiddenUserOperationError_1 = __importDefault(require("../errors/ForbiddenUserOperationError"));
const InvalidPasswordError_1 = __importDefault(require("../errors/InvalidPasswordError"));
const MissingAttributesError_1 = __importDefault(require("../errors/MissingAttributesError"));
const UnauthorisedError_1 = __importDefault(require("../errors/UnauthorisedError"));
const UserNotFoundError_1 = __importDefault(require("../errors/UserNotFoundError"));
const GetProviderUsersError_1 = __importDefault(require("../errors/GetProviderUsersError"));
const SignInViaEmailLinkError_1 = __importDefault(require("../errors/SignInViaEmailLinkError"));
class AuthenticationServiceClient extends client_library_1.Client {
    constructor(fetch, options, encryptPassword) {
        super(fetch, options);
        this.encryptPassword = encryptPassword;
    }
    updateMyEmail(email) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!email) {
                throw new client_library_1.MissingParamError('email');
            }
            const url = `${this.url}/api/authentication/email/me`;
            const expectedResponses = [200, 404, 409, 422];
            const response = yield this.requestMaker.makeRequest(url, {
                method: 'POST',
                body: JSON.stringify({ email })
            }, expectedResponses);
            if (response.status === 404) {
                throw new UserNotFoundError_1.default();
            }
            if (response.status === 409) {
                const body = response.json;
                throw new EmailAlreadyExistsError_1.default(body.reason);
            }
            if (response.status === 422) {
                const body = response.json;
                throw new AuthenticationBodyNotValidError_1.default(body.pointer, body.reason);
            }
            return response.json;
        });
    }
    adminResetPassword({ userId, newPassword }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!userId) {
                throw new client_library_1.MissingParamError('userId');
            }
            if (!newPassword) {
                throw new client_library_1.MissingParamError('newPassword');
            }
            const url = `${this.url}/api/admin/authentication/reset-password`;
            const expectedResponses = [200, 401, 404, 422];
            const encryptedPassword = yield this.encryptPassword(newPassword);
            const response = yield this.requestMaker.makeRequest(url, {
                method: 'POST',
                body: JSON.stringify({
                    userId,
                    newPassword: encryptedPassword
                })
            }, expectedResponses);
            if (response.status === 401) {
                throw new UnauthorisedError_1.default();
            }
            if (response.status === 404) {
                throw new FirebaseUserNotFoundError_1.default(userId);
            }
            if (response.status === 422) {
                throw new InvalidPasswordError_1.default();
            }
            return response.json;
        });
    }
    resetStudentPassword({ classId, userId, newPassword }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!classId) {
                throw new client_library_1.MissingParamError('classId');
            }
            if (!userId) {
                throw new client_library_1.MissingParamError('userId');
            }
            if (!newPassword) {
                throw new client_library_1.MissingParamError('newPassword');
            }
            const url = `${this.url}/api/authentication/reset-password`;
            const expectedResponses = [200, 404, 403, 422];
            const encryptedPassword = yield this.encryptPassword(newPassword);
            const response = yield this.requestMaker.makeRequest(url, {
                method: 'POST',
                body: JSON.stringify({
                    classId,
                    userId,
                    newPassword: encryptedPassword
                })
            }, expectedResponses);
            if (response.status === 403) {
                throw new ForbiddenUserOperationError_1.default(userId);
            }
            if (response.status === 404) {
                throw new FirebaseUserNotFoundError_1.default(userId);
            }
            if (response.status === 422) {
                throw new InvalidPasswordError_1.default();
            }
            return response.json;
        });
    }
    sanitizeEmail(email) {
        return email && email.toLocaleLowerCase();
    }
    getUsersByProvider(users) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.url}/api/admin/get-users-by-provider`;
            const expectedResponses = [200, 400];
            const response = yield this.requestMaker.makeRequest(url, {
                method: 'POST',
                body: JSON.stringify({
                    users
                })
            }, expectedResponses);
            if (response.status === 400) {
                const body = response.json;
                throw new GetProviderUsersError_1.default(body.reason);
            }
            return response.json;
        });
    }
    updateUserLastVisit({ lastVisitTime, browser, appVersion }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!lastVisitTime)
                throw new MissingAttributesError_1.default('lastVisitTime');
            const url = `${this.url}/api/authentication/last-visit/me`;
            const expectedResponses = [200];
            const response = yield this.requestMaker.makeRequest(url, {
                method: 'POST',
                body: JSON.stringify({
                    lastVisitTime,
                    browser,
                    appVersion
                })
            }, expectedResponses);
            return response.json;
        });
    }
    /**
     * Create or update users based on email and/or provider data.
     * Only in case where it's permissible to omit email e.g. GS user from this field that you can pass in no email.
     * @param param0
     * @returns
     */
    createOrUpdateUsers({ users, region }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!users)
                throw new client_library_1.MissingParamError('users');
            const url = `${this.url}/api/admin/create-or-update-users`;
            const expectedResponses = [200, 400, 422];
            const response = yield this.requestMaker.makeRequest(url, {
                method: 'POST',
                body: JSON.stringify({
                    users,
                    region
                })
            }, expectedResponses);
            if (response.status !== 200) {
                const body = response.json;
                throw new Error(`pointer: ${body.pointer}, reason: ${body.reason}`);
            }
            return response.json;
        });
    }
    createCustomToken({ userId }) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.url}/api/admin/custom-token`;
            const expectedResponses = [200, 400, 404, 422];
            const response = yield this.requestMaker.makeRequest(url, { method: 'POST', body: JSON.stringify({ userId }) }, expectedResponses);
            if (response.status !== 200) {
                const body = response.json;
                throw new Error(`pointer: ${body.pointer}, reason: ${body.reason}`);
            }
            return response.json;
        });
    }
    revokeUserRefreshTokens({ userId }) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.url}/api/admin/revoke-refresh-tokens`;
            const expectedResponses = [200, 400, 404, 422];
            const response = yield this.requestMaker.makeRequest(url, { method: 'POST', body: JSON.stringify({ userId }) }, expectedResponses);
            if (response.status !== 200) {
                const body = response.json;
                throw new Error(`pointer: ${body.pointer}, reason: ${body.reason}`);
            }
        });
    }
    sendSignInViaEmailLinkRequest({ email, callbackUrl }) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.url}/api/authentication/sign-in-link`;
            const expectedResponses = [200, 422, 500];
            const response = yield this.requestMaker.makeRequest(url, { method: 'POST', body: JSON.stringify({ email, callbackUrl }) }, expectedResponses);
            if (response.status === 422) {
                const body = response.json;
                throw new Error(`pointer: ${body.pointer}, reason: ${body.reason}`);
            }
            if (response.status === 500) {
                throw new SignInViaEmailLinkError_1.default(email, callbackUrl);
            }
        });
    }
}
exports.default = AuthenticationServiceClient;
